import { z } from 'zod/v3';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import { categoryCodes } from '../CategoryCode';
import translations from './CategoryValidFormDataSchema.translations.json';
import {
  errorMap,
  zCode,
  zDescription,
  zName,
  zValidPeriod,
  zSequenceNumber,
} from '../../../common/utils/schema';
import { ROW_UNIQUE_KEY_NAME } from '../../../common/utils/randomUniqueKey';
import { zUniqueKey } from '../../../common/utils/schema/zUniqueKey';

const { addTranslations, t } = i18nNsFactory('category-valid-form-data-schema');
addTranslations(translations);

export const CategoryRelationValidFormDataSchema = z.object({
  id: z.number().nullable(),
  subCategory: z
    .string(
      errorMap(() => t('validation.categoryRelations.subCategory.required')),
    )
    .min(1),
  subCategoryType: z.string(),
  sequenceNumber: zSequenceNumber(),
  validPeriod: zValidPeriod(),
});

export const CategoryValidFormDataSchema = z.object({
  id: z.number().nullable(),
  sequenceNumber: zSequenceNumber(),
  code: z.union([zCode(), z.enum(categoryCodes)]),
  name: zName(errorMap(() => t('validation.categories.name.required'))).min(1),
  nameEng: zName(),
  description: zDescription(),
  validPeriod: zValidPeriod(),
  categoryRelations: z.array(CategoryRelationValidFormDataSchema),
  [ROW_UNIQUE_KEY_NAME]: zUniqueKey(),
  parentKey: zUniqueKey().nullable(),
  levelNumber: z.coerce.number(),
  childSequenceNumber: z.coerce.number(),
});
